import React from 'react';
import { Tooltip } from 'react-tooltip';
import * as PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { trim } from 'lodash-es';
import { withTranslation, useTranslation } from 'react-i18next';
import { UserFields } from './form-user-fields';
import { FormControlsDecorated } from './form-controls';
import { CustomFieldsMap, FIELDS } from 'components/forms';
import { viewRangeSelector } from 'common/selectors/integration';
import { RESPONSIVE_RANGES } from 'utils/enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';

const contentValidation = (value) => !(value && trim(value));

const HashTagHintToolTip = () => {
  const { t } = useTranslation();

  return (
    <>
      <span
        data-tooltip-content={t('new_comment_hashtag_tooltip')}
        data-tooltip-id="hashtagTooltip"
        data-delay-show={100}
        className="ct-hashtag-hint-tooltip"
      >
        <FontAwesomeIcon icon={faQuestionCircle} />
      </span>
      <Tooltip id="hashtagTooltip" place="top" effect="float" type="dark" className={'e-hashtag-hint'} />
    </>
  );
};

const NewCommentForm = (p) => (
  <div className="ct-new-comment-form" data-e2e="newCommentForm">
    <form onSubmit={p.handleSubmit}>
      <div className="row">
        {p.withUserFields && <UserFields t={p.t} />}

        <div className="e-field col-12">
          {p.isMobileForm ? (
            <Field name="content" component={'input'} required validate={[contentValidation]} />
          ) : (
            <div>
              <span className="e-title">
                {p.t('comment')} <HashTagHintToolTip />
              </span>
              <Field name="content" component={'textarea'} required validate={[contentValidation]} />
            </div>
          )}

          <FormControlsDecorated toggleFormAction={p.toggleFormAction} />

          {p.textBox &&
            CustomFieldsMap[FIELDS.TEXT_BOX]({
              placeholder: 'Text Box',
              required: false,
              data: p.textBox,
            })}
        </div>
      </div>
    </form>
  </div>
);

const mapStateToProps = (state) => {
  const range = viewRangeSelector(state);
  const isMobileForm = range === RESPONSIVE_RANGES.MOBILE_SMALL || range === RESPONSIVE_RANGES.MOBILE_LARGE;

  return {
    isMobileForm,
  };
};

const NewCommentFormDecorated = compose(
  reduxForm({
    form: 'commentsForm', // a unique identifier for this form
  }),
  withTranslation(),
  connect(mapStateToProps)
)(NewCommentForm);

NewCommentFormDecorated.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  toggleFormAction: PropTypes.func.isRequired,
  withUserFields: PropTypes.bool.isRequired,
  textBox: PropTypes.string,
};

export { NewCommentFormDecorated };
